import { writable } from 'svelte/store';

export const loading = writable(false)

loading.subscribe(v=>{
    console.log("Loading",v)
})